// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2-LHD","tab":"Tabs_tab__HR7ZB","tabActive":"Tabs_tabActive__1v0jc"};